/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2RhcnlsYmVyZ2Vyb24vRG9jdW1lbnRzL3dlYnN0dWZmL2FuZ3VsYXIvZmlyZW5vdGVzL3NyYy9hcHAvbm90ZS1kZXRhaWwvbm90ZS1kZXRhaWwuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9kYXJ5bGJlcmdlcm9uL0RvY3VtZW50cy93ZWJzdHVmZi9hbmd1bGFyL2ZpcmVub3Rlcy9zcmMvYXBwL25vdGUtZGV0YWlsL25vdGUtZGV0YWlsLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/note-detail/note-detail.component.css.shim.ngstyle.ts